import { Alert, AlertDescription, AlertTitle } from "@getgreenline/blaze-ui";
import { ShieldAlert } from "lucide-react";
import type { ReactNode } from "react";
import { useAuthStore } from "@/stores/auth-store";

export function StaffAccessGate({ children }: { children: ReactNode }) {
  const realm = useAuthStore((state) => state.realm);

  if (realm !== "staff") {
    return (
      <main className="tw:flex tw:min-h-[60vh] tw:items-center tw:justify-center tw:px-6">
        <Alert className="tw:max-w-lg">
          <ShieldAlert className="tw:size-4" />
          <AlertTitle>Staff access required</AlertTitle>
          <AlertDescription>
            Brand user administration is available only to authenticated staff
            members.
          </AlertDescription>
        </Alert>
      </main>
    );
  }

  return <>{children}</>;
}
